<a [href]="href" class="voltar"><img src="/assets/icons/voltar.svg" /> Voltar</a>
